import { TvSource } from '@reliance/types/models/Tv';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { useMemo } from 'react';

export type TvSourceFilters = {
  facilityId?: number | null;
  name?: string | null;
  enabled?: boolean | null;
  macAddress?: string | null;
  page?: number;
  perPage?: number;
  orderBy?: string;
};

export function useTvSources(filters?: TvSourceFilters | null) {
  const filterKey = useMemo(() => JSON.stringify(filters), [filters]);
  return useAsync<PaginatedResponse<TvSource>>(
    async () => {
      const params = filters ? { ...filters } : {};
      const res = await api.get<PaginatedResponse<TvSource>>('/tv/source', { params });
      return res.data;
    },
    [filterKey]
  );
}

export function useTvSource(id: number | null) {
  return useAsync<TvSource | null>(
    async () => {
      if (id == null) return null;
      const res = await api.get<TvSource>(`/tv/source/${id}`);
      return res.data;
    },
    [id]
  );
}
